export function addCurrent(workhour) {
    return {
        type: 'ADD_CURRENT',
        workhour,
    }
}
